import script from "./ProductServiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductServiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductServiceDetail.vue?vue&type=style&index=0&id=913ac27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-913ac27e"]])

export default __exports__